import React from "react";

interface CardListProps {
	children: React.ReactNode;
	className?: string;
}

const CardList: React.FC<CardListProps> = ({ children, className }) => {
	const tailwindColor = {
		active: "#f7feff",
		accent: "#29303E",
		inactive: "#5f5766",
		background: "#121929"
	};
	// CSS for webkit scrollbars (needs to be inserted)
	//
	const scrollbarCss = `
    .scrollbar-thin::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    
    .scrollbar-trackColor::-webkit-scrollbar-track {
        background: ${tailwindColor.background};
        border-radius: 3px;
    }
    
    .scrollbar-thumbColor::-webkit-scrollbar-thumb {
        background: ${tailwindColor.active};
        border-radius: 3px;
    }
    
    .scrollbar-thumbHoverColor::-webkit-scrollbar-thumb:hover {
        background: ${tailwindColor.inactive};
    }
  `;

	return (
		<>
			{/* Scrollable container */}
			<div
				className={`overflow-y-auto pr-4
          scrollbar-thin scrollbar-trackColor scrollbar-thumbColor 
          hover:scrollbar-thumbHoverColor min-h-0 ${className}`}
			>
				<style>{scrollbarCss}</style>

				<div className="space-y-4">{children}</div>
			</div>
			{/* </div> */}
		</>
	);
};

export default CardList;
